import { Spinner } from "@/icons";
import {
  AggregationItemCard,
  Button,
  Row,
  SectionHeading,
} from "../../components";
import "./CommunicationContents.scss";
import Masonry from "react-layout-masonry";

export type CommunicationContentsProps = {
  sectionId?: string;
  title: string;
  elements: any[];
  total: number;
  totalLabels?: {
    first: string;
    middle: string;
    end: string;
  };
  loading?: boolean;
  handleLoadMore: () => void;
  showMoreTitle?: string;
  noResultsLabel?: string;
};

export function CommunicationContents({
  title,
  elements = [],
  total,
  totalLabels = { first: "Stai visualizzando", middle: "di", end: "elementi" },
  handleLoadMore,
  loading = false,
  showMoreTitle = "Visualizza altro ",
  noResultsLabel = "Nessun risultato trovato",
}: CommunicationContentsProps) {
  const showMoreButtonVisible = total > elements?.length;

  return (
    <section className="communication-contents d-flex section-gap flex-column">
      <SectionHeading className="title" title={title} />
      <Masonry
        columns={{ 0: 1, 768: 2, 1025: 3 }}
        gap={24}
        className="masonry-component"
      >
        {elements?.map((element) => (
          <AggregationItemCard {...element} key={element._id} />
        ))}
      </Masonry>
      <Row className="w-full-adpt" justifyContent="center" m="x12">
        {loading && <Spinner height={30} width={30} />}
      </Row>
      <span className="total-elements-label">
        {elements?.length === 0 ? (
          <span>{noResultsLabel}</span>
        ) : (
          <>
            <span>{totalLabels.first}</span>
            <Row justifyContent="center" gap="x4">
              <b>{elements?.length}</b>
              <span>{totalLabels.middle}</span>
              <span>{total}</span>
              <span>{totalLabels.end}</span>
            </Row>
          </>
        )}
      </span>
      {showMoreButtonVisible && !loading && elements?.length > 0 && (
        <Row justifyContent="center" alignItems="center" mt="x16">
          <Button onClick={handleLoadMore}>{showMoreTitle}</Button>
        </Row>
      )}
    </section>
  );
}
